import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import Url from '../../utils/url';

const styles = {
  main: {
    maxWidth: '400px',
    minWidth: '250px',
  },
  paper: {
    padding: '60px 30px',
  },
  header: {
    paddingBottom: '20px',
  },
  button: {
    margin: '20px 0 10px',
  },
  bottom: {
    marginTop: '20px',
  }
};

class SsoLogout extends Component {

  async componentDidMount() {
    localStorage.setItem("SsoLoggedIn", false);
  }

  renderLogo = () => {
    const src = localStorage.logo ? localStorage.logo : `/Home/GetLogo`;

    return <img src={src} height="40" alt="logo" style={styles.header} />;
  };

  renderContactText = () => {
    if (this.props.helperText) {
      return <p>{this.props.helperText}</p>;
    } else {
      return null;
    }
  };

  navigateToLogin = () => {
    window.localStorage.setItem("SsoLoggedIn", false);

    let logoutPath = localStorage.DefiUserLogin === "true" ? '/ui/login/defilogin' : '/ui/login';
    let redirectUrl = Url.addReturnUrlParameter(logoutPath);
    Url.updateRedirectUrlInStore();

    window.location.href = decodeURIComponent(redirectUrl);
  };

  render() {

    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4" style={styles.main}>
        <div className="box">
          <Paper elevation={3} style={styles.paper}>

            <div className="row center-xs">
              <div className="col-xs-12">
                <div className="box">{this.renderLogo()}</div>
              </div>

              <div className="col-xs-12">
                <p>You have successfully signed out. </p>
              </div>

              <div className="col-xs-12">
                <div className="box">
                  <div />
                  <Button
                    variant="contained"
                    id="submit-button"
                    type="submit"
                    style={styles.button}
                    className="submitButton"
                    color="primary"
                    onClick={() => this.navigateToLogin()}
                  >
                    Login
                  </Button>
                </div>
              </div>
              <div className="col-xs-8">
                <div className="box">
                  {this.renderContactText()}
                </div>
              </div>
            </div>

          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>

    );
  }
}

export default SsoLogout;
